import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActionComponent } from '../../../../ui/api/action.component';
import { ResultComponent } from '../../../../ui/api/result.component';
import { WishlistToggleAbstract } from '../toggle/wishlist-toggle.abstract';

@Component({
    selector: 'wishlist-carousel-remove',
    templateUrl: './wishlist-carousel-remove.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, ResultComponent]
})
export class WishlistCarouselRemoveComponent extends WishlistToggleAbstract {}
